import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import {
  BarChartOutlined,
  ClusterOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import {
  JMIX_REPORTS_PAGE_SECURITY_TOKENS,
  JMIX_REPORTS_PATH,
} from "@/modules/jmix-reports/pages/jmix-reports";
import { REPORTS_MAIN_PATH } from "@/modules/reports/pages/main";
import { SUPERSET } from "@/shared/modules/constants/modules-id";
import { EnabledTokens } from "gql/graphql";

export const reportMenu: NavigationItem[] = [
  {
    label: "reports menu",
    icon: <BarChartOutlined />,
    children: [
      {
        label: "reports",
        icon: <ContainerOutlined />,
        to: JMIX_REPORTS_PATH,
        requiredAtLeastOnePermission: JMIX_REPORTS_PAGE_SECURITY_TOKENS,
      },
      {
        label: "Superset",
        icon: <ClusterOutlined />,
        to: REPORTS_MAIN_PATH,
        requiredModule: SUPERSET,
        requiredAtLeastOnePermission: [EnabledTokens.AnalyticsSuperset],
      },
    ],
  },
];
